import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'

import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import footerbg from '../Assets/Images/footerbg.jpg'
import { MdEmail } from "react-icons/md";

export default function WebFooter() {
  return (
    <>
      <Col lg={12}>
        <div className='p-1' style={{
          backgroundImage: `url(${footerbg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          backgroundRepeat: 'no-repeat',
        }}>
          <Container>
            <Row className='mt-5'>
              <Col lg={5}>
                <h5 className='text-white'>Mobius Unity Consulting</h5>
                <p className='text-white'>
                  Mobius Unity Consulting empowers regenerative industries through strategic planning, sustainable innovation, and collaborative solutions. We bridge the gap between nature and technology to support agriculture, clean energy, water systems, and community development — enabling impactful, future-ready growth for organizations worldwide.
                </p>
              </Col>
              <Col lg={3} className='justify-content-end'>
                <h5 className='text-light'>Quick Links</h5>
                <ul className='list-unstyled text-white'>
                  <li><MdKeyboardDoubleArrowRight /><a href='/' className='quick-links'>Home</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='aboutus' className='quick-links'>AboutUs</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='services' className='quick-links'>Services</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='intro-strategy-sessions' className='quick-links'>Intro & Strategy Sessions</a></li>
                  <li><MdKeyboardDoubleArrowRight /><a href='contact' className='quick-links'>Contact </a></li>
                </ul>
              </Col>

              <Col lg={4}>
                <h5 className='text-light'>Connect With us</h5>
                <p className='text-white'><MdEmail/> david@mobiusunityconsulting.com</p>
              </Col>

              
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} <strong>Mobius Unity Consulting </strong> |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a>
              </p>
            </div>
          </Container>
        </div>
      </Col>
    </>
  )
}
